$(document).ready(function(){
$('.dropdown-menu a.dropdown-toggle').on('click', function(e) {
    if (!$(this).next().hasClass('show')) {
      $(this).parents('.dropdown-menu').first().find('.show').removeClass('show');
    }
    var $subMenu = $(this).next('.dropdown-menu');
    $subMenu.toggleClass('show');
  
  
    $(this).parents('li.nav-item.dropdown.show').on('hidden.bs.dropdown', function(e) {
      $('.dropdown-submenu .show').removeClass('show');
    }); 
  
    return false;
  });
  
  
    $(".banner-slider .owl-carousel").owlCarousel({
      loop:true,
      autoplay:true,
      margin:10,
      nav:true,
      items: 1,
      dots: false,
      navText : ["<i class='fas fa-chevron-left'></i>","<i class='fas fa-chevron-right'></i>"], 
    });

    $(".category-slider-1 .owl-carousel").owlCarousel({
      loop:true,
      margin:10,
      mouseDrag: false,
      autoplay:false,
      nav:true,
      items: 3,
      dots: false,
      nav:false,
    });

    $(".category-slider-2 .owl-carousel").owlCarousel({
      loop:true,
      margin:10,
      mouseDrag: false,
      autoplay:false,
      dots: false,
      nav:true,
      navText : ["<i class='fas fa-chevron-left'></i>","<i class='fas fa-chevron-right'></i>"], 
      responsive:{
        0:{
            items:1,
            nav:true,
          
        },
        600:{
            items:3,
            nav:true,
        },
        1000:{
            items:6,
          nav:true,
        }
    }
    });

    $(".product-slider .owl-carousel").owlCarousel({
      loop:true,
      margin:18,
      responsiveClass:true,
      nav:true,
      autoplay:true,
      items: 1,
      dots: false,
      navText : ["<i class='fas fa-chevron-left'></i>","<i class='fas fa-chevron-right'></i>"],
      responsive:{
        0:{
            items:1,
            nav:true
        },
        575:{
          items:2,
          nav:false
      },
        991:{
            items:2,
            nav:false
        },
        1000:{
            items:4,
            nav:true,
            loop:false
        }
    }
    });

    $(".supply-carousel .owl-carousel").owlCarousel({
      loop:true,
      margin:18,
      responsiveClass:true,
      nav:true,
      autoplay:true,
      items: 5,
      dots: false,
      navText : ["<i class='fas fa-chevron-left'></i>","<i class='fas fa-chevron-right'></i>"],
      responsive:{
        0:{
            items:1,
            nav:true
        },
        575:{
          items:2,
          nav:false
      },
        991:{
            items:2,
            nav:false
        },
        1000:{
            items:5,
            nav:true,
            loop:false
        }
    }
    });

    $(".carousel-reviews .owl-carousel").owlCarousel({
      loop:true,
      margin:20,
      responsiveClass:true,
      nav:true,
      items: 4,
      autoplay:true,
      dots: false,
      navText : ["<i class='fas fa-chevron-left'></i>","<i class='fas fa-chevron-right'></i>"],
      responsive:{
        0:{
            items:1,
            nav:true
        },
        575:{
          items:2,
          nav:false
      },
        991:{
            items:2,
            nav:false
        },
        1000:{
            items:4,
            nav:true,
            loop:false
        }
    }
    });

    new Drift(document.querySelector('.drift-demo-trigger'), {
      paneContainer: document.querySelector('#details-container'),
      inlinePane: 500,
      inlineOffsetY: -85,
      containInline: true,
      hoverBoundingBox: true
    });
  });

$(document).ready(function () {
     $('.mega-menu').mouseover(function () {
        $(this).attr('open', 'true');
     })  
 $('.mega-menu').mouseout(function () {
$(this).removeAttr('open' );
     })     
 });

$(document).ready(function() {
  $('#add-to-cart-form').submit(function(event) {
    event.preventDefault(); // prevent the default form submit behavior

    var form = $(this);
    var addToCartButton = form.find('.button');
    var originalButtonText = addToCartButton.text();

    addToCartButton.attr('disabled', true).text('Adding...'); // disable the button and change the text

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: form.serialize(),
      dataType: 'json',
      success: function() {
        addToCartButton.text('Added!'); // change the button text
        setTimeout(function() {
          addToCartButton.attr('disabled', false).text(originalButtonText); // re-enable the button and change the text back to the original text after a delay
        }, 1000);
      },
      error: function() {
        addToCartButton.text('Error'); // handle the error by changing the button text
      }
    });
  });
});
